/**
 * What a push that reached the open app is, from its `type` (InGo's
 * `Modules/Push/Messages`): only an offer may ring. Kept apart from
 * `driverPush.js` (which loads the native push plugin) so the rule is tested
 * on its own.
 *
 * - `delivery_update`: a client's delivery update (`DeliveryUpdate`);
 * - `test`: the office's "Send a test notification" (`TestNotification`),
 *   never an offer: before 2 Oct 2026 any unknown type rang as one;
 * - `stop`: an offer withdrawn (`offer_stop` or `stop`);
 * - `offer`: anything else, as before (the offer's own message names no type).
 *
 * @param {{ type?: string } | null | undefined} data the message's data
 * @param {{ type?: string } | null | undefined} [payload]
 * @returns {'delivery_update' | 'test' | 'stop' | 'offer'}
 */
export function pushKind(data, payload) {
  const type = String(data?.type || payload?.type || '').toLowerCase();
  if (type === 'delivery_update') return 'delivery_update';
  if (type === 'test') return 'test';
  if (type === 'offer_stop' || type === 'stop') return 'stop';

  return 'offer';
}
